/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export function displayTelemetryTooltip(event, scope, compile, telemetryValue, telemetryValueLbl, telemetryTimestamp, valueColor) {
  var instances = angular.element.tooltipster.instances();
  instances.forEach((instance) => {
    instance.destroy();
  });
  var element = angular.element(event.target);
  element.tooltipster(
      {
        theme: 'tooltipster-shadow',
        delay: 100,
        trigger: 'custom',
        triggerOpen: {
          click: false,
          tap: false
        },
        triggerClose: {
          click: true,
          tap: true,
          scroll: true
        },
        trackOrigin: true
      }
  );

  var contentElement = angular.element('<div class="ag-telemetry-tooltip">' +
      '<a class="ag-telemetry-tooltip-close-button" id="close" style="outline: none;">×</a>' +
      '<div id="tooltip-content" layout="column">' +
      '<div class="ag-telemetry-ts">'+telemetryTimestamp+'</div>'+
      '<div layout="column" layout-align="center center">' +
      '<div class="ag-telemetry-value" style="color: ' + valueColor + ';">'+telemetryValueLbl+'</div>'+
      '</div>' +
      '</div>' +
      '</div>');
  compile(contentElement)(scope);
  var tooltip = element.tooltipster('instance');
  contentElement.find('#close').on('click', function() {
    tooltip.destroy();
  });
  tooltip.content(contentElement);
  tooltip.open();
}
